"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("../Select"));

var _Field = _interopRequireDefault(require("./Field"));

var _FieldContent = _interopRequireDefault(require("./FieldContent"));

require("./Form.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(_ref) {
  var id = _ref.id,
      name = _ref.name,
      options = _ref.options,
      label = _ref.label,
      error = _ref.error,
      help = _ref.help,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      noOptionsMessage = _ref.noOptionsMessage,
      isClearable = _ref.isClearable,
      isDisabled = _ref.isDisabled,
      isMulti = _ref.isMulti,
      isSearchable = _ref.isSearchable,
      autoFocus = _ref.autoFocus,
      placeholder = _ref.placeholder,
      restProps = _objectWithoutProperties(_ref, ["id", "name", "options", "label", "error", "help", "value", "onChange", "onBlur", "noOptionsMessage", "isClearable", "isDisabled", "isMulti", "isSearchable", "autoFocus", "placeholder"]);

  return _react.default.createElement(_Field.default, _extends({}, restProps, {
    htmlFor: id,
    label: label,
    error: error,
    help: help
  }), _react.default.createElement(_FieldContent.default, null, _react.default.createElement(_Select.default, _extends({
    id: id,
    name: name,
    options: options,
    error: error,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    autoFocus: autoFocus,
    noOptionsMessage: noOptionsMessage,
    isClearable: isClearable,
    isDisabled: isDisabled,
    isMulti: isMulti,
    isSearchable: isSearchable,
    placeholder: placeholder
  }, restProps))));
};

exports.default = _default;